import useSWR from 'swr'
// this hook helps us build an infinite loading UI.
// this usually happens with a "load more" button triggering more requests
// https://swr.vercel.app/docs/pagination
import useSWRInfinite from 'swr/infinite'

import getConfig from 'next/config'

type FetcherNormal = (args: string) => Promise<Response>

const fetcherNormal: FetcherNormal = (args) => fetch(args).then((res) => res.json())

const config = getConfig()?.publicRuntimeConfig

type FetchArticles = (
  articleIds: string[],
  lang: string
) => {
  data: any
  isError: any
  isLoading: boolean
}

export const useFetchArticles: FetchArticles = (articleIds, lang) => {
  const { data, error } = useSWR(
    `https://${config.CONTENTFUL_BLOG_BUILDER_CLIENT_CONFIG.host}/spaces/${
      config.CONTENTFUL_BLOG_BUILDER_SPACE
    }/environments/master/entries?access_token=${
      config.CONTENTFUL_BLOG_BUILDER_DELIVERY_TOKEN
    }&content_type=article&locale=${lang}-CA&sys.id[in]=${articleIds.join()}`,
    fetcherNormal
  )

  return {
    data: data,
    isLoading: !error && !data,
    isError: error,
  }
}

type Fetcher = (articleIds: string, lang: string) => Promise<Response>

const fetcher: Fetcher = async (articleIds, lang) => {
  const url = `https://${config.CONTENTFUL_BLOG_BUILDER_CLIENT_CONFIG.host}/spaces/${config.CONTENTFUL_BLOG_BUILDER_SPACE}/environments/master/entries?access_token=${config.CONTENTFUL_BLOG_BUILDER_DELIVERY_TOKEN}&content_type=article&locale=${lang}-CA&sys.id[in]=${articleIds}`
  const res = await fetch(url)
  return await res.json()
}

type FetchArticlesInfinity = (
  articleIds: string,
  selectedCategory: string,
  selectedTags: string[],
  lang: string
) => {
  data: any[]
  isError: any
  isLoading: boolean
  size: number
  setSize: (size: number | ((_size: number) => number)) => Promise<Response[]>
}

export const useFetchArticlesInfinity: FetchArticlesInfinity = (articleIds, selectedCategory, selectedTags, lang) => {
  const { data, error, size, setSize } = useSWRInfinite(
    (index) => {
      return [selectedCategory, selectedTags, index]
    },
    () => fetcher(articleIds, lang),
    { initialSize: 0, revalidateFirstPage: false, revalidateAll: false }
  )

  return {
    data: data,
    isLoading: !error && !data,
    isError: error,
    size,
    setSize,
  }
}
